export function getFormattingFunction(_a) {
    var wixApi = _a.wixApi, platformServices = _a.platformServices, formatingCurrency = _a.formatingCurrency;
    var createCurrencyFormatter = platformServices.essentials.createCurrencyFormatterWithDefaults({
        language: getFormattingLanguage(wixApi),
    });
    var formatCurrency = createCurrencyFormatter();
    return function (amount) { return formatCurrency({ value: amount, currency: formatingCurrency !== null && formatingCurrency !== void 0 ? formatingCurrency : 'USD' }); };
}
function getMLLocale(wixApi) {
    var currentLang = getCurrentlyUsedMultilingualLanguage(wixApi);
    if (!currentLang) {
        return undefined;
    }
    return currentLang.locale || wixApi.window.multilingual.currentLanguage;
}
function getFormattingLanguage(wixApi) {
    var _a, _b;
    return (_b = (_a = getMLLocale(wixApi)) !== null && _a !== void 0 ? _a : wixApi.site.regionalSettings) !== null && _b !== void 0 ? _b : 'en-US';
}
function getCurrentlyUsedMultilingualLanguage(wixApi) {
    var currentShortLang = wixApi.window.multilingual.currentLanguage;
    return wixApi.window.multilingual.siteLanguages.find(function (lang) { return lang.languageCode === currentShortLang; });
}
//# sourceMappingURL=getFormattingFunction.js.map